import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-telefonos',
  templateUrl: './telefonos.component.html',
  styleUrls: ['./telefonos.component.scss']
})
export class TelefonosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
